

import React, { memo, useState } from 'react';
import { Button, RadioButton, Input } from '../../../ui-kit';

const REASONS = [
'I would like to subscribe to Shootsta!',
'I would like more information on pricing',
'I am unsure, and would like to talk through some questions'];






function GetInTouchForm({
  onSubmit
}) {
  const [submitting, setSubmitting] = useState(false);
  const [selectedReason, setSelectedReason] = useState(REASONS[0]);
  const [otherReason, setOtherReason] = useState('');

  return (
    <>
      <ul className="get-in-touch-modal__reasons">
        {REASONS.map((reason) =>
        <li
          key={reason}
          className="get-in-touch-modal__reasons__item">

            <RadioButton
            key={reason}
            selected={selectedReason === reason}
            onChange={() => setSelectedReason(reason)}>

              {reason}
            </RadioButton>
          </li>
        )}

      </ul>
      <Input
        className="get-in-touch-modal__other-reason"
        value={otherReason}
        placeholder="Leave your message here"
        onChange={({ target: { value } }) => setOtherReason(value)}
        rows={4}
        multiline
        labelProps={{ required: true }} />

      <Button
        className="get-in-touch-modal__btn"
        onClick={() => onSubmit(setSubmitting, selectedReason, otherReason)}
        busy={submitting}>

        Submit
      </Button>
    </>);

}

export default memo(GetInTouchForm);